import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import Modal from 'common-components/Modal';

import './imageModal.style.css';


const ImageModal = ({
  screenshotLink,
  showImageModal,
  setShowImageModal
}) => {
  const modalContent = () => {
    return (
      <>
        <TransformWrapper
          defaultScale={10}
          defaultPositionX={200}
          defaultPositionY={250}
        >
          <TransformComponent>
            <img
              className='screenshot'
              src={screenshotLink}
              alt='Screenshot'
            />
          </TransformComponent>
        </TransformWrapper>
      </>
    )
  };

  return (
    <div className='image-modal-container'>
      <Modal
        showModal={showImageModal}
        setShowModal={setShowImageModal}
        content={modalContent()}
      />
    </div>
  )
};

export default ImageModal;